import React from 'react';
import PanelImage from './green-bcp';
import PmiOverviewImage from './pmi-overview-image';
import PmiMonthlyEnergyImage from './pmi-monthly-energy-image';

import './monitor-images.css';

export default function MonitorImages() {
  return (
    <div className="monitor-images-grid">
      <PanelImage className="monitor-panel-image" />
      <PmiOverviewImage />
      <PmiMonthlyEnergyImage />
    </div>
  );
}
